
import { FilterOps, GQL_ID } from '@@types'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'


import stylesLayout from '@pages/catalog/ui/styles.module.scss'

import { useFetchShopProducts } from '@entities/Product'
import { useSingleProductGroup } from '@entities/ProductGroup/api/singleProductGroup.gql'

import { CartPreview } from '@features/cart'
import { useAddressStore } from '@features/shipping-methods'


import { CategoriesSidebar } from '@widgets/categories-branch'
import ProductsInfiniteScroll from '@widgets/products-infinite-scroll'


import { IMAGE_SIZES, URL_PAGE_CATALOG } from '@shared/contants'
import { cn } from '@shared/lib/cn'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import PageGrid from '@shared/ui/page-grid'
import TitleWithCount from '@shared/ui/title-with-count'
import Wrapper from '@shared/ui/wrapper'
import getNoun from '@shared/uttils/getNoun'

import styles from './styles.module.scss'

const LIMIT = 12

export default function ProductGroupProductsPage () {
  const { t: tn } = useTranslation('navigation')
  const { t: tp } = useTranslation('product')
  const isTablet = useMediaQuery('(max-width: 991px)')
  const { shopId } = useAddressStore()
  const params = useParams()

  const productGroupId = params.productGroupId as GQL_ID

  const { data: productGroupData } = useSingleProductGroup({
    id: productGroupId,
    shop_id: shopId,
    style: IMAGE_SIZES.LARGE
  })

  const productGroupLabel = productGroupData?.singleProductGroup?.label ?? ''

  const { products, pageInfo, loading, fetchNextPage, hasMore, loadingMore } = useFetchShopProducts({
    shopId: shopId,
    page: 1,
    limit: LIMIT,
    filter: {
      fields: [ 'productGroupIds' ],
      op: FilterOps.CONTAINS,
      value: [ productGroupId ]
    }
  })

  const totalProducts = pageInfo?.total ?? 0

  return (
    <Container>
      <PageGrid aside={<CartPreview />}>
        <Wrapper className={styles.wrapper}>
          <div className={stylesLayout.grid}>
            <Breadcrumbs
              className={stylesLayout.breadcrumbs}
              links={[
                {
                  title: tn('catalog'),
                  to: URL_PAGE_CATALOG
                },
                {
                  title: productGroupLabel
                }
              ]}
            />
            {!isTablet && (
              <div className={cn(stylesLayout.aside, styles.aside)}>
                <div className={styles.aside}>
                  <CategoriesSidebar className={styles.aside__content} />
                </div>
              </div>
            )}
            <div className={cn(stylesLayout.content)}>
              <div className={styles.root__top}>
                <TitleWithCount
                  className={styles.root__title}
                  title={productGroupLabel}
                >
                  {totalProducts !== null && (
                    <>
                      {totalProducts}{' '}
                      {getNoun(
                        totalProducts as number,
                        tp('product.1'),
                        tp('product.2'),
                        tp('product.3'),
                      )}
                    </>
                  )}
                </TitleWithCount>
              </div>
              <ProductsInfiniteScroll
                products={products}
                loading={loading}
                fetchNextPage={fetchNextPage}
                hasMore={hasMore}
                loadingMore={loadingMore}
              />
            </div>
          </div>
        </Wrapper>
      </PageGrid>
    </Container>
  )
}